import { useEffect, useState } from "react"

import { CopilotMessage } from "./MessageList"
import {
  CopilotCreateSuggestionResult,
  CopilotEndpoint,
  CopilotResponse,
} from "./types"

export const COPILOT_ACTIONS = {
  PRACTICE_PROBLEM: {
    prompt: "Generate a practice problem",
    endpoint: CopilotEndpoint.CreatePracticeProblem,
  },
  ALTERNATIVE_EXPLANATION: {
    prompt: "Explain in a different way",
    endpoint: CopilotEndpoint.CreateAlternativeExplanation,
  },
}

const useCopilotConversation = (
  responses: CopilotResponse[] | undefined,
  mutationWrapper: (
    endpoint: CopilotEndpoint
  ) => Promise<CopilotCreateSuggestionResult>
) => {
  const [messages, setMessages] = useState<CopilotMessage[]>([])

  useEffect(() => {
    if (responses === undefined) return

    setMessages(
      responses.flatMap(({ prompt, response }) => [
        { text: prompt, fromUser: true },
        { text: response, fromUser: false },
      ])
    )
  }, [responses])

  const createCopilotSuggestion = (
    prompt: string,
    endpoint: CopilotEndpoint
  ) => {
    setMessages(currentMessages => [
      ...currentMessages,
      { text: prompt, fromUser: true },
    ])
    mutationWrapper(endpoint)
      .then(result => {
        const { failures, copilotResponse } =
          result.data.copilotCreateSuggestion

        const message =
          failures.length > 0 ? failures[0].message : copilotResponse

        setMessages(currentMessages => [
          ...currentMessages,
          { text: message, fromUser: false },
        ])
      })
      .catch(() => {
        setMessages(currentMessages => [
          ...currentMessages,
          { text: "Something went wrong. Please try again.", fromUser: false },
        ])
      })
  }

  return { messages, createCopilotSuggestion }
}

export default useCopilotConversation
